import React from 'react';
import Slider from 'react-slick';
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


const BlogSlider = () => {

    const [data, setData] = useState("");
    const [currentIndex, setCurrentIndex] = useState(0);
    const sliderRef = useRef(null);
    let navigate= useNavigate();   

    useEffect(() => {
        setTimeout(() => {
            const url = "https://sbvmapi.uniservedata.in/api/content?nameType=Latest News";
            GetData(url);
        }, 2000);
    }, []);

    useEffect(() => {
        if (data.length > 0 && sliderRef.current) {
            const interval = setInterval(() => {
                const slideCount = data.length;
                const nextIndex = currentIndex < slideCount - 1 ? currentIndex + 1 : 0;
                setCurrentIndex(nextIndex);
                sliderRef.current.slickGoTo(nextIndex);
            }, 6000);

            return () => {
                clearInterval(interval);
            };
        }
    }, [currentIndex, data]);

    const GetData = async (url) => {
        const data = await fetch(url);
        const res = await data.json();
        setData(res.content_data);
        console.log(res.content_data);
    }

    const getImg = (url) => {
        const parts = url.split("\/");
        const newurl = "https://sbvmapi.uniservedata.in/image/" + parts[1];
        return newurl;
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        /*  autoplay: true,
         autoplaySpeed: 5000,  */
        initialSlide: currentIndex,
        afterChange: (index) => setCurrentIndex(index),

    };

    const routeChange = (id) => {
      let path = "Home/" + id;
      navigate(path);
    }


    return (
        <div className="news_section layout_padding">
            <div className="container">
                <h1 className="news_taital">Recent News
                    <hr
                        style={{
                            height: '3px',
                            backgroundColor: 'currentColor',
                            width: '18%',
                            margin: '14px auto 17px',
                            border: 'none',
                        }}
                    /></h1>
                <div className="news_box mb-5"  style={{ minHeight: '300px' }}>
                    <Slider {...settings} ref={sliderRef}>
                        {data.length > 0 &&
                            data.map((slide, index) => (
                                <div key={index} className="container py-4">
                                <div className="row align-items-center" style={{ minHeight: '300px' }}>
                                  
                                  {/* LEFT: TEXT */}
                                  <div className="col-md-6 text-center text-md-start">
                                    <h1>
                                      {slide.heading}
                                      <hr
                                        style={{
                                          height: '3px',
                                          backgroundColor: 'currentColor',
                                          width: '28%',
                                          margin: '14px auto 17px',
                                          border: 'none',
                                        }}
                                      />
                                    </h1>
                                    <p
                                      className="card-text mt-3"
                                      dangerouslySetInnerHTML={{
                                        __html: slide.textData
                                          ?.split(' ')
                                          .slice(0, 80)
                                          .join(' ') + '...',
                                      }}
                                    ></p>
                                     <button className="buttoncust" onClick={()=>routeChange(slide._id)}>Read More</button>
                                  </div>
                              
                                  {/* RIGHT: IMAGE */}
                                  <div className="col-md-6">
                                    <div
                                      className="w-100 zoom-container"
                                      style={{
                                        height: '300px',
                                        overflow: 'hidden',
                                      
                                      }}
                                    >
                                      <img
                                        src={getImg(slide.img)}
                                        alt={`Slide ${index + 1}`}
                                        className="w-100 h-100 zoom-img"
                                        style={{
                                          objectFit: 'cover',
                                          transition: 'transform 0.6s ease',
                                        
                                        }}
                                      />
                                    </div>
                                  </div>
                              
                                </div>
                              </div>
                              
                            ))}
                    </Slider>
                </div>

            </div>

        </div>
    );
};

export default BlogSlider;
